const DocumentType = {
    PERSONAL_AGREEMENT: 'PERSONAL_AGREEMENT',
    PLATFORM_RULES: 'PLATFORM_RULES',
};

export default DocumentType;
